import React from 'react';

export default function TivHeader({ onProfileClick }) {
  return (
    <div className="flex flex-col items-center mb-5 relative">
      <div className="w-16 h-16 rounded-2xl bg-blue-600/20 flex items-center justify-center mb-4">
        <span className="text-3xl font-extrabold text-blue-400">T</span>
      </div>
      <h1 className="text-xl font-bold text-white">Tiv</h1>
      <p className="text-sm text-zinc-500 mt-1">Lettres de motivation Parcoursup</p>
      {onProfileClick && (
        <button
          onClick={onProfileClick}
          className="mt-3 text-xs text-violet-400 hover:text-violet-300 transition-colors"
        >
          Profil Tiv
        </button>
      )}
    </div>
  );
}
